import { ACI_MULTI_HARDWARE_TABLE_DATA } from "./constants";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";

const AciMultiHardware = () => {
  return (
    <>
      <Table variant="striped" border={"2px solid rgb(237,242,247)"}>
        <Thead>
          <Tr>
            <Th>V2 Hardware</Th>
            <Th>Purpose</Th>
            <Th>Qty</Th>
            <Th>Software Version</Th>
          </Tr>
        </Thead>
        <Tbody>
          {ACI_MULTI_HARDWARE_TABLE_DATA.map((item, index) => {
            return (
              <Tr key={index}>
                <Td>{item.v2_hardware}</Td>
                <Td>{item.purpose}</Td>
                <Td>{item.qty}</Td>
                <Td>{item.software_version}</Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </>
  );
};

export default AciMultiHardware;
